export default type => `${type}-${Math.round(Math.random() * 100000)}`;